module.exports = __webpack_public_path__ + "static/policy_book1_3@2x-43a229c59274071387752a1e7a96a3c2.png";